import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XHRBackend, RequestOptions } from '@angular/http';
//import { MaterialModule } from '@angular/material';


import { AngularReduxRequestOptions } from './angular-redux-request.options';
import { LoaderService } from './loader/loader.service';
import { LoaderComponent } from './loader/loader.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@NgModule({
    imports: [
        CommonModule,
        MatProgressBarModule
        //MaterialModule
    ],
    exports: [
        LoaderComponent
    ],
    declarations: [
        LoaderComponent
    ],
    providers: [
        LoaderService,

    ]
})

export class CoreModule { }
